import { getFaqLIstFun, supFaqCount } from '../../../api/supportAdmin';
import errorHandle from '../../../utils/errorHandle';

export default async function getFaqs(setFaqData, setLoading, type, limit, offset) {
    setLoading(true);
    try {
        const faq = await getFaqLIstFun(type, limit, offset);
        setFaqData(faq.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
}

export const faqCount = (setTotalCount, setLoading, type) => {
    setLoading(true);
    try {
        supFaqCount(type).then((res) => {
            setLoading(false);
            setTotalCount(res.data.count);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
